import React from "react";
import axios from "axios";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SignIn from "./pages/SignIn";
import UserDashboard from "./pages/UserDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import JobEntryForm from "./pages/JobEntryForm";
import Masters from "./pages/Masters";

// Attach the admin bearer token (if logged in) to every API request.
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<SignIn />} />
        <Route path="/user" element={<UserDashboard />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/masters" element={<Masters />} />
        <Route path="/user/new" element={<JobEntryForm />} />
      </Routes>
    </Router>
  );
}

export default App;
